
import { props } from './embla'

export default {
  name: 'VsCarouselThumbs',
  inject: ['carousel'],
  props: {
    ...props,
    align: {
      type: String,
      default: 'center'
    },
    containScroll: {
      type: String,
      default: 'keepSnaps'
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 0,
      scrolling: false
    }
  },
  watch: {
    active(value) {
      if (!this.scrolling && this.thumbs) {
        this.scrolling = true

        this.carousel.scrollTo(value)
        this.thumbs.scrollTo(value)

        this.scrolling = false
      }
    }
  },
  computed: {
    itemsPerView() {
      return this.$screen.match(this.slidesPerView)
    },
    items() {
      return this.carousel.items || []
    }
  },
  methods: {
    onCreate(thumbs) {
      this.thumbs = thumbs
    },
    onClick(index) {
      this.active = index
    },
    onSelect({ active }) {
      if (this.itemsPerView == 1) {
        this.active = active
      }
    },
    sync({ active }) {
      this.active = active
    },
    isActive({ index }) {
      return this.active == index
    }
  },
  created() {
    this.carousel.$on('init', this.sync)
    this.carousel.$on('select', this.sync)
  },
  beforeDestroy() {
    this.carousel.$off('init', this.sync)
    this.carousel.$off('select', this.sync)
  }
}
